module.exports = __webpack_public_path__ + "img/timeline_mainevent-14.c879e068.jpg";